import { render, staticRenderFns } from "./secNav.vue?vue&type=template&id=4804d57f&scoped=true"
import script from "./secNav.vue?vue&type=script&lang=js"
export * from "./secNav.vue?vue&type=script&lang=js"
import style0 from "./secNav.vue?vue&type=style&index=0&id=4804d57f&prod&lang=scss&scoped=true"
import style1 from "./secNav.vue?vue&type=style&index=1&id=4804d57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804d57f",
  null
  
)

export default component.exports